import { UsuarioModel } from './../usuario/usuario.model';
export class TipoReajusteModel {
    id: number;
    descricao: String;
    prazo: number;
    usuario: UsuarioModel;
}



// WEBPACK FOOTER //
// /app/src/app/model/cliente/tiporeajuste.model.ts